// @ts-expect-error "color hash errors if we don't import the ESM version"
import ColorHash from "color-hash/dist/esm"

const colorHash = new ColorHash({ saturation: 1.0 })

export const stringToColor = (s: string): string => colorHash.hex(s)

export function generateColors(s: string): [string, string] {
  const s1 = s.substring(0, s.length / 2)
  const s2 = s.substring(s.length / 2)
  const c1 = stringToColor(s1)
  const c2 = stringToColor(s2)

  return [c1, c2]
}
